/*
 * Params:
 * docId, page (0 based), size
 */
import { clientFetch } from '../clientFetch';

export const relatedClinicalTrialSearch = (params) => {
  return clientFetch('/search/clinical-trials/related', { params });
};
